import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-7797">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-7798">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-7799">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-7800">
            <ArrowLeft className="w-4 h-4" data-id="element-7801" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-7802">NOIZA</div>
          <div className="w-20" data-id="element-7803" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-7804">
        <div className="mb-12" data-id="element-7805">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-7806">
            <FileText className="w-6 h-6 text-white/80" data-id="element-7807" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-7808">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-7809">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-7810">
          <section data-id="element-7811">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-7812">
              <span className="text-[#006847]" data-id="element-7813">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-7814">
              <p data-id="element-7815">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-7816">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-7817">
                <li data-id="element-7818">Haber leído íntegramente este documento</li>
                <li data-id="element-7819">Comprender su contenido en su totalidad</li>
                <li data-id="element-7820">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-7821">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-7822">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-7823">
              <span className="text-[#006847]" data-id="element-7824">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-7825">
              <p data-id="element-7826">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-7827">
                <li data-id="element-7828">Software como servicio (SaaS)</li>
                <li data-id="element-7829">Marketplace digital gastronómico</li>
                <li data-id="element-7830">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-7831">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-7832">
                <li data-id="element-7833">Mostrar su menú digital</li>
                <li data-id="element-7834">Recibir pedidos de clientes</li>
                <li data-id="element-7835">Gestionar su operación interna</li>
                <li data-id="element-7836">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-7837">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-7838">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-7839">
              <span className="text-[#006847]" data-id="element-7840">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-7841">
              <p data-id="element-7842">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-7843">
                <li data-id="element-7844">No es proveedor de alimentos</li>
                <li data-id="element-7845">No participa en la preparación de productos</li>
                <li data-id="element-7846">No manipula alimentos en ningún momento</li>
                <li data-id="element-7847">No realiza entregas ni logística</li>
                <li data-id="element-7848">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-7849">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-7850">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-7851">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-7852">
              <span className="text-[#006847]" data-id="element-7853">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-7854">
              <p data-id="element-7855">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-7856">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-7857">
                <li data-id="element-7858">El restaurante es el único responsable de su operación</li>
                <li data-id="element-7859">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-7860">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-7861">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-7862">
                <li data-id="element-7863">Precios</li>
                <li data-id="element-7864">Menú</li>
                <li data-id="element-7865">Horarios</li>
                <li data-id="element-7866">Métodos de pago</li>
                <li data-id="element-7867">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-7868">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-7869">
              <span className="text-[#006847]" data-id="element-7870">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-7871">
              <div data-id="element-7872">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-7873">
                  5.1. Alcance general
                </h3>
                <p data-id="element-7874">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-7875">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-7876">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-7877">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-7878">
                  <li data-id="element-7879">Calidad de los alimentos</li>
                  <li data-id="element-7880">Estado, frescura o preparación</li>
                  <li data-id="element-7881">Ingredientes utilizados</li>
                  <li data-id="element-7882">Contaminación cruzada</li>
                  <li data-id="element-7883">Problemas de higiene o salubridad</li>
                  <li data-id="element-7884">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-7885">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-7886">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-7887">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-7888">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-7889">
                  <li data-id="element-7890">Retrasos en la entrega</li>
                  <li data-id="element-7891">Pérdida de pedidos</li>
                  <li data-id="element-7892">Entregas incompletas</li>
                  <li data-id="element-7893">Errores en dirección</li>
                  <li data-id="element-7894">Conducta de repartidores</li>
                  <li data-id="element-7895">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-7896">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-7897">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-7898">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-7899">
                  <li data-id="element-7900">Recepción de pagos</li>
                  <li data-id="element-7901">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-7902">Manejo de efectivo</li>
                  <li data-id="element-7903">Confirmación de pagos</li>
                  <li data-id="element-7904">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-7905">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-7906">
                  <li data-id="element-7907">Pagos no recibidos</li>
                  <li data-id="element-7908">Comprobantes falsos</li>
                  <li data-id="element-7909">Errores en montos</li>
                  <li data-id="element-7910">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-7911">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-7912">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-7913">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-7914">
                  <li data-id="element-7915">Reclamos de clientes</li>
                  <li data-id="element-7916">Reembolsos</li>
                  <li data-id="element-7917">Cancelaciones</li>
                  <li data-id="element-7918">Disputas</li>
                  <li data-id="element-7919">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-7920">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-7921">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-7922">
              <span className="text-[#006847]" data-id="element-7923">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-7924">
              <p data-id="element-7925">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-7926">
                <li data-id="element-7927">Responsable</li>
                <li data-id="element-7928">Legal</li>
                <li data-id="element-7929">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-7930">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-7931">
                <li data-id="element-7932">Publicar información falsa</li>
                <li data-id="element-7933">Manipular precios de forma engañosa</li>
                <li data-id="element-7934">Simular disponibilidad inexistente</li>
                <li data-id="element-7935">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-7936">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-7937">
              <span className="text-[#006847]" data-id="element-7938">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-7939">
              <p data-id="element-7940">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-7941">
                <li data-id="element-7942">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-7943">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-7944">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-7945">
                <li data-id="element-7946">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-7947">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-7948">
                    <li data-id="element-7949">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-7950">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-7951">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-7952">
              <span className="text-[#006847]" data-id="element-7953">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-7954">
              <p data-id="element-7955">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-7956">
                <li data-id="element-7957">Menú digital</li>
                <li data-id="element-7958">Gestión de pedidos</li>
                <li data-id="element-7959">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-7960">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-7961">
                  <p className="font-medium text-white mb-2" data-id="element-7962">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-7963">
                    <li data-id="element-7964">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-7965">
                  <p className="font-medium text-white mb-2" data-id="element-7966">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-7967">
                    <li data-id="element-7968">Propiedad del software</li>
                    <li data-id="element-7969">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-7970">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-7971">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-7972">
              <span className="text-[#006847]" data-id="element-7973">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-7974">
              <p data-id="element-7975">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-7976">
                <li data-id="element-7977">Disponibilidad continua</li>
                <li data-id="element-7978">Funcionamiento sin interrupciones</li>
                <li data-id="element-7979">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-7980">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-7981">
                <li data-id="element-7982">Fallas técnicas</li>
                <li data-id="element-7983">Actualizaciones</li>
                <li data-id="element-7984">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-7985">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-7986">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-7987">
              <span className="text-[#006847]" data-id="element-7988">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-7989">
              <p data-id="element-7990">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-7991">
                <li data-id="element-7992">No está garantizada permanentemente</li>
                <li data-id="element-7993">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-7994">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-7995">
                <li data-id="element-7996">Destacar o no restaurantes</li>
                <li data-id="element-7997">Modificar posiciones</li>
                <li data-id="element-7998">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-7999">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8000">
              <span className="text-[#006847]" data-id="element-8001">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-8002">
              <p data-id="element-8003">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8004">
                <li data-id="element-8005">Cumplir con los pagos acordados</li>
                <li data-id="element-8006">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-8007">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8008">
                <li data-id="element-8009">Suspender el servicio</li>
                <li data-id="element-8010">Limitar funcionalidades</li>
                <li data-id="element-8011">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8012">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8013">
              <span className="text-[#006847]" data-id="element-8014">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-8015">
              <p data-id="element-8016">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8017">
                <li data-id="element-8018">Incumplimiento de términos</li>
                <li data-id="element-8019">Uso indebido</li>
                <li data-id="element-8020">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-8021">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-8022">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8023">
              <span className="text-[#006847]" data-id="element-8024">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-8025">
              <p data-id="element-8026">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-8027">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-8028">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8029">
              <span className="text-[#006847]" data-id="element-8030">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-8031">
              <p data-id="element-8032">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8033">
                <li data-id="element-8034">Pérdidas económicas</li>
                <li data-id="element-8035">Daños indirectos</li>
                <li data-id="element-8036">Lucro cesante</li>
                <li data-id="element-8037">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8038">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8039">
              <span className="text-[#006847]" data-id="element-8040">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-8041">
              <p data-id="element-8042">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-8043">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8044">
              <span className="text-[#006847]" data-id="element-8045">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-8046">
              <p className="font-medium" data-id="element-8047">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-8048">
                <li data-id="element-8049">Ha leído este documento completo</li>
                <li data-id="element-8050">Comprende su alcance</li>
                <li data-id="element-8051">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}